import React from "react";

import { Box, Card, makeStyles } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(1, 2),
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    maxHeight: "96px",
  },
}));

const CardSkeleton: React.FC = () => {
  const classes = useStyles();
  return (
    <Card className={classes.root}>
      <Box flexGrow={1}>
        <Skeleton variant="text" width="100%" height={32} />
        <Skeleton variant="text" width="100%" height={32} />
      </Box>
    </Card>
  );
};

export default CardSkeleton;
